import type { GetStaticProps } from 'next'
import ImageBanner from '@components/ImageBanner'
import type { pageTitle, pageContent } from '@lib/types'
import { getPageTitleContentFromDB, getPageContentFromDB } from '@lib/pagequerys'
import { CarouselBasic } from '@components/Carousels'
import { Container, Heading, Section, Text, LinkComponent } from '@components/SectionComponents'

export const getStaticProps: GetStaticProps = async () => {

    // page_id in DB
    const pageIdDB: number = 31;

    // query DB for page title data
    const pageTitle: pageTitle = await getPageTitleContentFromDB(pageIdDB);

    // Array of pageContent - query DB for pageContent data
    const pageContent: pageContent[] = await getPageContentFromDB(pageIdDB);

    return {
        props: {
            pageTitle,
            pageContent
        }
    }
}

// Page takes a pageTitle, and pageContent array
export default function Page({ pageTitle, pageContent }: {
    pageTitle: pageTitle,
    pageContent: pageContent[],
}) {

    return <>

        <ImageBanner title={pageTitle} subColor="brown" />

        {/* Section 0 */}
        <Section colour='brown'>
            <Container>
                <Heading h1={true} content={{ title: pageContent[0].title }} />
                <Text content={pageContent[0].text} />
            </Container>
        </Section>

        {/* Secton - 3 Stay 3, Pay 2 
        <Section colour='white'>
            <CarouselBasic images={pageContent[3].carouselImages} overlap='top' />

            <Container longer='both'>
                <Heading content={{ title: pageContent[3].title }} />
                <Text content={pageContent[3].text} />
                <LinkComponent link1={pageContent[3].link1} />
            </Container>
        </Section>
        */}

        {/* Secton 1 */}
        <Section colour='cream'>
            <CarouselBasic images={pageContent[1].carouselImages} overlap='top' />

            <Container longer='top'>
                <Heading content={{ title: pageContent[1].title }} />
                <Text content={pageContent[1].text} />
                <LinkComponent link1={pageContent[1].link1} />
            </Container>
        </Section>

        {/* Section 2 */}
        <Section colour='white'>
            <Container>
                <Heading content={{ title: pageContent[2].title }} />
                <Text content={pageContent[2].text} />
            </Container>
        </Section>
    </>;
}
//Meta Data
Page.title = "Exclusive Packages";
Page.description = "Make your visit to the Crocodile Hunter Lodge even more special by utilising one of our exclusive accommodation packages, personalised experiences which will help you create forever memories!";